import React from "react";
import { View, Platform } from "react-native";

import { sizes, colors, strings } from "assets/constants";
import Icon from "components/Icon";
import Text from "components/Text";

const TimePicker =
  Platform.OS === "web" ? require("react-ios-time-picker")?.TimePicker : null;

const WebTimePicker: React.FC<TimePickerT> = ({ value, error, onSelect }) => {
  return (
    <>
      <View
        style={{
          alignItems: "center",
          borderRadius: sizes.radius.xl,
          overflow: "hidden",
          width: 110,
          flexDirection: "row",
          borderWidth: 1,
          borderColor: colors.border,
          backgroundColor: colors.white,
          alignSelf: "flex-end",
        }}
      >
        <View style={{ flex: 1 }}>
          {TimePicker !== null && (
            <TimePicker
              inputClassName={{ backgroundColor: "red" }}
              placeHolder={strings.time}
              saveButtonText={strings.confirm}
              cancelButtonText={strings.cancel}
              onChange={onSelect}
              {...(value ? { value } : null)}
              // value={valueState || "12:00"}
            />
          )}
        </View>

        <View
          style={{
            width: 45,
            height: 45,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon name="clock" />
        </View>
      </View>
      {error && (
        <View
          style={{
            width: "100%",
            alignSelf: "flex-end",
            height: 20,
            paddingHorizontal: 5,
            bottom: Platform.OS === "web" ? -2 : 3,
          }}
        >
          <Text size={"xs"} color={colors.danger}>
            {error}
          </Text>
        </View>
      )}
    </>
  );
};

export default WebTimePicker;
